import React from "react";
import {Navigate, Route, Routes} from "react-router-dom"; // Use Routes and Navigate
import Login from "./shared/components/login";
import SignUp from "./shared/components/sign-up";
import Loader from "./shared/components/loader";
import Reset from "./shared/components/reset";
import './App.css';
import {getAccessToken} from "./shared/utils/SharedAuthentication";
import MainLayout from "./layouts/main-layout";
import ChangePassword from "./shared/components/change-password";
import ForgotPassword from "./shared/components/forgot-password";
import ChangeConfiguration from "./components/change-configuration";
import "react-toastify/dist/ReactToastify.css";
import {ToastContainer} from "react-toastify";
import axios from "axios";

function App() {
  return (
    <div className="App">
      <ChangePassword/>
      <ChangeConfiguration/>
      <Loader/>
      <ToastContainer position="bottom-right"/>
      <Routes>
        <Route path="/login" element={<Login/>}/>
        <Route path="/forgot-password" element={<ForgotPassword/>}/>
        <Route path="/reset" element={<Reset/>}/>
        <Route path="/sign-up" element={<SignUp/>}/>
        <Route path="/*" element={<PrivateRoute/>}/>
      </Routes>
    </div>
  );
}

axios.interceptors.request.use(
  async (config) => {
    try {
      const base = process.env.REACT_APP_HOST || window.location.origin;
      const serverCallUrl = new URL(config.url, base);

      if (
        serverCallUrl.pathname.includes("/oauth") ||
        serverCallUrl.pathname.includes("/auth") ||
        serverCallUrl.pathname.includes("/weather") ||
        serverCallUrl.pathname.includes("/extract")
      ) {
        return config;
      }

      const accessToken = typeof getAccessToken === "function" ? getAccessToken() : null;
      if (accessToken) {
        config.headers = {
          ...(config.headers || {}),
          authorization: `Bearer ${accessToken}`,
          "cache-control": "no-cache",
        };
      }
    } catch (e) {
      return config;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config || {};
    const status = error?.response && error.response.status;

    let path = "";
    try {
      const base = process.env.REACT_APP_HOST || window.location.origin;
      const serverCallUrl = new URL(originalRequest.url, base);
      path = serverCallUrl.pathname || "";
    } catch (_) {
    }

    if (status === 401 && !originalRequest._retry && !path.includes('/oauth')) {
      try {
        localStorage.clear();
      } catch (_) {
      }
      try {
        sessionStorage.clear();
      } catch (_) {
      }
      window.location.href = "/login";
      return;
    }

    return Promise.reject(error);
  }
);


// Update PrivateRoute to work with React Router v6
export const PrivateRoute = () => {
  // Check if the user has a valid access token
  if (getAccessToken()) {
    return <MainLayout/>;  // If the token exists, render the MainLayout
  } else {
    // Otherwise, redirect to login page
    return <Navigate to="/login"/>;
  }
};
export default App;
